export default __webpack_public_path__ + "static/media/lovelockdowntim.deded8a3.jpeg";